import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emptyForm, IBranchInvoiceMatrix } from "./Table";
import { Dialog } from 'primereact/dialog';
import { JVDropdown } from '../../shared/JVDropdown';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { Fetch } from '../../shared/Fetch';
import { Panel } from 'primereact/panel';

interface Iprops {
    singleData: IBranchInvoiceMatrix,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const percentage = [
    { name: "0", value: 0 },
    { name: "35", value: 35 },
    { name: "50", value: 50 },
    { name: "70", value: 70 },
    { name: "100", value: 100 },
];

const schema = yup.object({
    sales_Percentage: yup.number().min(0, "Recruiter Percentage is required*").required("Sales Percentage is required*"),
    recruiter_Percentage: yup.number().min(0, "Recruiter Percentage is required*").required("Recruiter Percentage is required*")
});

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IBranchInvoiceMatrix>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IBranchInvoiceMatrix) => {
        setLoading(true);
        const method = "PUT";
        const message = "Updated Successfully";

        const response = await Fetch("InvoiceTracking/updateBrancIncPercentage", method, body, null, props.toast);

        if (response) {
            props.setReload(!props.reload);
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.hideDialog();
            setLoading(false);
        } else setLoading(false);
    }

    const onHide = () => {
        setLoading(false);
        props.hideDialog();
        reset(emptyForm);
    }

    function onSubmit(data: IBranchInvoiceMatrix) {
        if ((Number(data.sales_Percentage || 0) + Number(data.recruiter_Percentage || 0)) > 100) {
            props.toast.current.show({ severity: 'error', detail: "Sum of Sales And Recruiter Branch Share Percentage Can Not Be Greater Than 100", life: 3000 });
        } else if ((Number(data.sales_Percentage || 0) + Number(data.recruiter_Percentage || 0)) <= 0) {
            props.toast.current.show({ severity: 'error', detail: "Sum of Sales And Recruiter Branch Share Percentage Can Not Be Less or Equal To 0", life: 3000 });
        } else {
            const newBody: IBranchInvoiceMatrix = {
                id: props.singleData.id,
                sales_Percentage: data.sales_Percentage,
                recruiter_Percentage: data.recruiter_Percentage,
            };
            saveToDB(newBody);
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Sales Recruiter Branch Percentage" modal className="p-fluid" onHide={onHide}>
            <div className="flex align-content-evenly w-full">
                <Panel header="Sales Company" style={{ width: "20%" }}>
                    <p className="m-0">{props.singleData.sales_Company}</p>
                </Panel>
                <Panel header="Sales Branch" style={{ width: "20%" }}>
                    <p className="m-0">{props.singleData.sales_Branch}</p>
                </Panel>
                <Panel header="Recruiter Company" style={{ width: "20%" }}>
                    <p className="m-0">{props.singleData.recruiter_Company}</p>
                </Panel>
                <Panel header="Recruiter Branch" style={{ width: "20%" }}>
                    <p className="m-0">{props.singleData.recruiter_Branch}</p>
                </Panel>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdown required label="Sales Branch Percentage" control={control} name="sales_Percentage" options={percentage} optionLabel="name" optionValue="value" placeholder="Select Sales Branch Percentage" error={errors.sales_Percentage?.message} />
                <JVDropdown required label="Recruiters Branch Percentage" control={control} name="recruiter_Percentage" options={percentage} optionLabel="name" optionValue="value" placeholder="Select Recruiters Branch Percentage" error={errors.recruiter_Percentage?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={loading} disabled={loading} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}